import ChangeCircleRoundedIcon from "@mui/icons-material/ChangeCircleRounded";
import PowerSettingsNewRoundedIcon from "@mui/icons-material/PowerSettingsNewRounded";
import { MenuItem } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import { persistor } from "../../../../../app/store/store";
import { ROLE } from "../../../../../utils/constants/profiles";
import SwitchTenant from "../itemsList/SwitchTenant/SwitchTenant";

const ListsSettings = ({ routes, isProfileIncomplete }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const appConfig = useSelector((state) => state.app.appConfig);
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const studioId = useSelector((state) => state.app.studioId);
  const multiTenant = useSelector((state) => state.app.hasMultiTenant);
  const role = useSelector((state) => state.app.role);

  const [switchTenant, setSwitchTenant] = useState(false);

  const handleLogoutClick = (e) => {
    persistor.purge();
    navigate("/login");
    window.location.reload();
  };

  return (
    <>
      {routes
        .filter((route) => {
          return route.isTopbarElement;
        })

        .map((route) => {
          const lastPathSegment = location.pathname.split("/").pop();
          if (
            (route.name === `${t("search-studio")}` && studioId) ||
            (route.name === `${t("myStudioRoute")}` && !studioId)
          ) {
            return null;
          }

          return (
            <MenuItem
              key={route.name}
              className={`h-16 space-x-2 ${
                lastPathSegment === route.path ? "bg-grey/80" : ""
              }`}
              onClick={() => {
                if (route.name === "terms")
                  appConfig?.customPolicyAndTerms?.terms
                    ? window.open(
                        appConfig?.customPolicyAndTerms?.terms,
                        "_blank"
                      )
                    : navigate(route.path);
                if (route.name === "privacy")
                  window.open(
                    role === ROLE.USER
                      ? appConfig?.customPolicyAndTerms?.userPolicy
                      : appConfig?.customPolicyAndTerms?.adminPolicy,
                    "_blank"
                  );
                if (!["privacy", "terms"].includes(route.name))
                  navigate(route.path);
              }}
              disabled={route.disabled || isProfileIncomplete}
            >
              <div className="flex mx-2">
                <div style={{ color: primaryColor }}>{route.icon}</div>
                <div className="mx-2">{route.label}</div>
              </div>
            </MenuItem>
          );
        })}
      {role === ROLE.USER && multiTenant !== "False" && (
        <MenuItem
          className="h-16 flex space-x-2 "
          onClick={() => setSwitchTenant(true)}
        >
          <div className="flex mx-2">
            <div style={{ color: primaryColor }}>
              <ChangeCircleRoundedIcon style={{ color: `${primaryColor}` }} />
            </div>
            <div className="mx-2">Cambia servizio</div>
          </div>
        </MenuItem>
      )}
      <MenuItem className="h-16 flex space-x-2 " onClick={handleLogoutClick}>
        <div className="flex mx-2">
          <div style={{ color: primaryColor }}>
            <PowerSettingsNewRoundedIcon className="" />
          </div>
          <div className="mx-2">Logout</div>
        </div>
      </MenuItem>

      <CoreModal
        width={"50%"}
        height={"50%"}
        state={switchTenant}
        onClose={() => setSwitchTenant(false)}
        component={<SwitchTenant onClose={() => setSwitchTenant(false)} />}
      />
    </>
  );
};

export default ListsSettings;
